<template>
    <div class="aba-emrpesa select-modal">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-prazo-pagamento"
                    />
                </div>

                <div
                    class="column situacao-select"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <label v-text="$t('situacao')" />
                    <v-select
                        ref="situacaoInput"
                        class="is-100"
                        label="label"
                        :options="situacoes"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                    >
                        <template slot="option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>

                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModal = !showModal"
                    >
                        {{ $t('vincular-prazo-pagamento') }}
                    </button>
                </div>

                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCadastroPrazoPagamento"
                    >
                        {{ $t('adicionar-prazo-pagamento') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assprazopagtoempresalist"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                    >
                        <template v-slot:header>
                            <span
                                v-if="
                                    f.key == 'reajuste' ||
                                    f.key == 'valorpedidominimo' ||
                                    f.key == 'data-hora'
                                "
                            >
                                {{ $t(f.key) }}
                                <b-icon
                                    class="m-0"
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="$t(`informacao-tooltip-${f.key}`)"
                                />
                            </span>
                            <span v-else-if="f.key == 'margempedido'">
                                {{ $t(f.key) }}
                                <b-icon
                                    class="m-0"
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="$t(`informacao-tooltip-margempedido-prazo`)"
                                />
                            </span>
                        </template>

                        <template v-slot="props">
                            <div v-if="f.key == 'excluir'">
                                <b-button
                                    v-if="permissao.update && !assPrazoPagtoEmpresaIntegracao"
                                    class="action-button"
                                    :type="
                                        props.row['replicapda'] == 3 ? 'is-danger' : 'is-success'
                                    "
                                    :icon-right="props.row['replicapda'] == 3 ? 'delete' : 'check'"
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy
                                    :title="
                                        $t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')
                                    "
                                />
                            </div>
                            <div v-else-if="f.key == 'prazo-pagamento'">
                                <a
                                    @click="selectedEdit(props.row)"
                                    v-if="!assPrazoPagtoEmpresaIntegracao && permissao.update"
                                >
                                    {{ props.row[f.key] }}
                                </a>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </div>
                            <div v-else-if="f.key == 'reajuste' || f.key == 'margempedido'">
                                {{ props.row[f.key] | decimal(2) }} %
                            </div>
                            <div v-else-if="f.key == 'valorpedidominimo'">
                                {{ prefix }} {{ props.row[f.key] | decimal(2) }}
                            </div>
                            <div v-else-if="f.key == 'data-hora'">
                                {{ props.row[f.key] | moment('DD/MM/YYYY HH:mm:ss') }}
                            </div>
                            <div v-else-if="f.key == 'replicapda'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-if="props.row['replicapda'] == 3"
                                    type="is-success"
                                    size="is-medium"
                                    >{{ $t('ativo') }}</b-tag
                                >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-else
                                    type="is-danger"
                                    size="is-medium"
                                    >{{ $t('inativo') }}</b-tag
                                >
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </template>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO VINCULAR -->
            <b-modal v-if="modalManage == false" :active="showModal" @close="fecharModal">
                <div class="bg">
                    <PrazoPagamentoSelectModal
                        :idempresa="$route.params.id"
                        @fecharModal="fecharModal"
                        @selected="selected"
                    />
                </div>
            </b-modal>

            <b-modal v-else :active="showModal" @close="promptChangeTab">
                <div class="bg">
                    <PrazoPagamentoManageModal
                        :selected="assprazopagtoempresa"
                        @fecharModal="fecharModal"
                        @promptChangeTab="promptChangeTab"
                        @isChangedModal="isChangedModal = $event"
                    />
                </div>
            </b-modal>

            <!-- MODAL DE CADASTRO PRAZO DE PAGAMENTO -->
            <b-modal :active.sync="modalCadastroPrazoPagamento" @close="fecharModal">
                <div>
                    <PrazoPagamentoCadastroModal
                        @fecharModal="fecharModal"
                        @cadastrado="cadastrado"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssPrazoPagamentoEmpresa from '@/services/vendas/empresa/abas/AssPrazoPagamentoEmpresaService';
import PrazoPagamentoSelectModal from '../modal/PrazoPagamentoSelectModal.vue';
import PrazoPagamentoManageModal from '../modal/PrazoPagamentoManageModal.vue';
import PrazoPagamentoCadastroModal from '../modal/PrazoPagamentoCadastroModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        PrazoPagamentoSelectModal,
        PrazoPagamentoManageModal,
        PrazoPagamentoCadastroModal,
    },
    data() {
        return {
            assPrazoPagtoEmpresaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSPRAZOPAGTOEMPRESA'
            ),
            prazoPagtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PRAZOPAGTO'),
            assprazopagtoempresalist: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'prazo-pagamento', width: null, sortable: true, sortFn: null },
                { key: 'reajuste', width: null, sortable: false, sortFn: null },
                { key: 'margempedido', width: null, sortable: false, sortFn: null },
                { key: 'valorpedidominimo', width: null, sortable: false, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new AssPrazoPagamentoEmpresa(this.$http, this.$router),
            permissao: false,
            permissaoCadastroPrazoPagamento: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacao: { id: 4, label: 'todos' },
            situacoes: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'prazo-pagamento',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModal: false,
            modalCadastroPrazoPagamento: false,
            modalManage: false,
            assprazopagtoempresa: null,
            permissaoVincular: false,
            permissaoCadastrar: false,
            prefix: this.$store.state.empresas.data[0].simbolomonetario,
            isUpdate: false,

            // @71071 - variável que controla edição
            isChangedModal: false,

            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'empresa',
                'ven-empresa-politica-comercial-prazo-pagamento'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'empresa',
                'agro-empresa-politica-comercial-prazo-pagamento'
            );
        }

        this.permissaoCadastroPrazoPagamento = this.hasPermissionAccess(
            'vendas',
            'vendas',
            'ven-prazo-pagamento'
        );

        this.permissaoVincular = this.permissao.create && !this.assPrazoPagtoEmpresaIntegracao;
        this.permissaoCadastrar =
            this.permissaoCadastroPrazoPagamento.create && !this.prazoPagtoIntegracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'prazo-pagamento' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacao.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.assprazopagtoempresalist = value;
                    this.isEmpty = this.assprazopagtoempresalist.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de preços.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idempresa, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idassprazopagtoempresa: m.idassprazopagtoempresa,
                    codigo: m.prazopagto.idprazopagtoerp,
                    'prazo-pagamento': m.prazopagto.descricao,
                    reajuste: m.reajuste,
                    margempedido: m.margempedido,
                    'data-hora': m.datahorainc,
                    valorpedidominimo: m.valorpedminimo,
                    replicapda: m.replicapda,
                    idassprazopagto: m.idassprazopagtoempresa,
                    idprazopagto: m.prazopagto.idprazopagtoerp,
                    idempresa: m.idempresa,
                    valorpedminimo: m.valorpedidominimo,
                    indicepedido: m.indicepedido,
                    margemmediapedido: m.margemmediapedido,
                    colunavenda: m.colunavenda,
                    colunadesconto: m.colunadesconto,
                    qtdeparcelas: m.qtdeparcelas,
                    prazoinicial: m.prazoinicial,
                    prazomaximo: m.prazomaximo,
                    prazominimo: m.prazominimo,
                    prazomediomaximo: m.praziomediomaximo,
                    prazomedio: m.praziomedio,
                    valorpedmaximo: m.valorpedmaximo,
                    idcampanha: m.idcampanha,
                    prazofixo: m.prazofixo,
                    flexivel: m.flexivel,
                    validaparcelasflexivel: m.validaparcelasflexivel,
                    ignoraregrasaldocliente: m.ignoraregrasaldocliente,
                    prazopagto: m.prazopagto,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['prazo-pagamento'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-reativar-associacao-prazo-pagamento'
                    : 'msg-erro-ao-desativar-associacao-prazo-pagamento';

            let tempAssprazopagtoempresa = {
                idassprazopagtoempresa: this.delete.idassprazopagtoempresa,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssprazopagtoempresa)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-prazo-pagamento'
                                : 'msg-sucesso-ao-desativar-associacao-prazo-pagamento';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assprazopagtoempresa) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assprazopagtoempresa);
            else return this.service.updateSituacaoAgro(assprazopagtoempresa);
        },
        showModalPrazoPagtNaoAssociados() {
            this.isUpdate = false;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        showModalCadastroPrazoPagamento() {
            this.modalCadastroPrazoPagamento = !this.modalCadastroPrazoPagamento;
        },

        /* @71071 - Aviso para que antes de fechar o Modal de edição do vínculo prazo
        de pagamento, exista a possibilidade de não perder os dados que foram mudados */
        promptChangeTab() {
            if (this.isChangedModal) {
                this.$root.confirm({
                    message: this.$t('msg-tem-certeza-alteracoes'),
                    onConfirm: (_) => {
                        this.fecharModal();
                    },
                });
            } else {
                this.fecharModal();
            }
        },
        fecharModal() {
            this.showModal = false;
            this.isUpdate = false;
            this.modalManage = false;
            this.modalCadastroPrazoPagamento = false;
            this.carregarDados();
        },
        selected(selected) {
            this.modalManage = true;
            this.assprazopagtoempresa = selected;
        },
        selectedEdit(selected) {
            this.modalManage = true;
            this.isUpdate = true;
            this.assprazopagtoempresa = selected;
            this.showModal = true;
        },
        cadastrado(prazopagamento) {
            this.modalCadastroPrazoPagamento = false;
            this.isUpdate = true;
            this.modalManage = true;
            this.assprazopagtoempresa = prazopagamento;
            this.assprazopagtoempresa['idempresa'] = this.$route.params.id;
            this.showModal = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-emrpesa {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
